<template>
  <div class="footer">
    <div class="footer-body content-center">
      <div class="footer-body-left">
        <!-- <div class="company-info">隆创信息有限公司</div>
        <div class="company-info">地址：南京市雨花台区宁双路19号云密城F栋12层</div>
        <div class="company-info">电话：400-009-2860</div>
        <div class="company-info">邮箱：admin@longstron.com</div> -->
        <img class="longstron-logo" src="@/assets/img/layout/logo.png" alt="易隆创" />
        <div class="company-info">通过技术驱动生态融合，致力于成为新型基础</div>
        <div class="company-info">建设领域数字业务的“基石”</div>
        <div class="official-accounts">
          <div class="item-box">
            <img class="item-qrcode" src="@/assets/img/qrcode/douyin_account.png">
            <img class="item-icon" src="@/assets/img/layout/icon_douyin.png">
          </div>
          <div class="item-box">
            <img class="item-qrcode" src="@/assets/img/qrcode/official_accounts.png">
            <img class="item-icon" src="@/assets/img/layout/icon_weixin.png">
          </div>
        </div>
        <div class="blogroll">友情链接：<a class="link" href="https://www.longstron.com/" target="_blank">隆创信息官网</a></div>
      </div>
      <div class="footer-body-right">
        <!-- <div class="link-menu">
          <div class="link-menu-title">热门方案</div>
          <a class="link-menu-item" v-for="item in schemeList" :key="item.id" :href="`#/scheme/view?id=${item.id}`">{{ item.name }}</a>
        </div> -->
        <div class="link-menu">
          <div class="link-menu-title">四大生态</div>
          <a class="link-menu-item">合伙人生态</a>
          <a class="link-menu-item">服务能力生态</a>
          <a class="link-menu-item">供应链生态</a>
          <a class="link-menu-item">解决方案生态</a>
        </div>
        <div class="link-menu">
          <div class="link-menu-title">隆创介绍</div>
          <a class="link-menu-item" href="https://www.longstron.com/about-us" target="_blank">关于我们</a>
          <a class="link-menu-item" href="https://www.longstron.com/solution" target="_blank">解决方案</a>
          <a class="link-menu-item" href="https://www.longstron.com/project-case" target="_blank">项目案例</a>
          <a class="link-menu-item" href="https://www.longstron.com/recruitment" target="_blank">人才招聘</a>
          <a class="link-menu-item" href="https://www.longstron.com/contact-us" target="_blank">联系我们</a>
        </div>
      </div>
    </div>
    <div class="statement">
      <div class="content-center">
        <span class="text">Copyright © 2019-{{ new Date().getFullYear() }} 隆创信息有限公司 All Rights Reserved. </span>
        <a class="text link" href="https://beian.miit.gov.cn/" target="_blank">备案号：苏ICP备14056357号-5</a>
        <a class="text link" href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
          <img class="badge" src="@/assets/img/police_badge.png">苏公网安备：32011402010117号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import * as SchemeApi from '@/api/scheme';

export default {
  data() {
    return {
      isShowCode: false,
      schemeList: [],
    }
  },
  created() {
    this.getSchemeList();
  },
  methods: {
    async getSchemeList() {
      try {
        const res = await SchemeApi.queryLimit({ pageSize: 3, type: 'home', hot: true });
        if (res?.code === '00000') {
          this.schemeList = res.rows;
        }
      } catch (error) {
        console.error('获取数据失败', error);
      }
    },
  }
}
</script>

<style scoped lang='less'>
.footer {
  background-color: #1E1C1D;

  .footer-body {
    padding: 45px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: #fff;

    .footer-body-left {
      .longstron-logo {
        width: 80px;
        margin-top: -20px;
      }
      .company-info {
        margin-bottom: 12px;
        font-size: 14px;
        &:first-child {
          margin-bottom: 20px;
        }
      }
      .official-accounts {
        display: flex;
        .item-box {
          position: relative;
          &:hover .item-qrcode {
            display: block;
          }
          + .item-box {
            margin-left: 16px;
          }
          .item-icon {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
          .item-qrcode {
            display: none;
            width: 120px;
            height: 120px;
            border-radius: 6px;
            position: absolute;
            top: -6px;
            left: 50%;
            transform: translate(-50%, -100%);
          }
        }
      }
      .blogroll {
        margin-top: 40px;
        font-size: 14px;
        color: #fff;
        .link {
          color: #fff;
          text-decoration: none;
          cursor: pointer;
          &:hover {
            color: @primary-color;
          }
        }
      }
    }

    .footer-body-right {
      display: flex;
      .link-menu {
        display: flex;
        flex-direction: column;
        + .link-menu {
          margin-left: 60px;
        }
        .link-menu-title {
          margin-bottom: 34px;
        }
        .link-menu-item {
          margin-bottom: 14px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          cursor: pointer;
          &:hover {
            color: @primary-color;
          }
        }
      }
    }
  }

  .statement {
    border-top: 1px solid #666;
    .content-center {
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      .text {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        text-decoration: none;
        display: flex;
        align-items: center;
        +.text {
          margin-left: 14px;
        }
        .badge {
          margin-right: 2px;
        }

        &.link {
          transition: color 0.2s ease;
          &:hover {
            color: @primary-color;
          }
        }
      }
    }
  }
}
</style>
